import NewApiService from "@/utils/new.api.service";

export default {
    list({ commit }) {
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pendingbox")
            .then(({ data }) => {
                commit("set_loading",false);
                commit("set_list",data.pendingBoxes);
                resolve(data.pendingBoxes);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        }); 
    },
    get({ commit }, id) {
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pendingbox/"+id)
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        }); 
    },
    getByOrderId({ commit }, orderId) {
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pendingbox/by-order/" + orderId)
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        }); 
    },
    add({commit}, model){
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.post("pendingbox", model)
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        }); 
    },
    returnProductToStock({commit}, params){
        const { boxId, productId } = params;
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.post("pendingbox/" + boxId + "/return", {productId})
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        });
    },
    
    returnAllProductsToStock({commit}, boxId){
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.post("pendingbox/" + boxId + "/return-all")
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        });
    },
    assignToAnotherBox({commit}, params){
        const { currentId, newId } = params;
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.post("pendingbox/"+ currentId +"/move", {newId})
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        });
    },
    getEmptyBox({commit}){
        commit("set_loading",true);
        return new Promise(resolve => {
            NewApiService.get("pendingbox/empty-box")
            .then(({ data }) => {
                commit("set_loading",false);
                commit("set_empty_box",data.pendingBox);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        });
    },
    manualPicking({commit}, params){
        commit("set_loading",true);
        const {boxId, items} = params;
        return new Promise(resolve => {
            NewApiService.put("pendingbox/"+boxId+"/manual-picking", {items})
            .then(({ data }) => {
                commit("set_loading",false);
                resolve(data);
            })
            .catch(({ response }) => {
                resolve(response.data.errors);
            });
        });
    }

}